export const fields =
    'author,id,excerpt,title,link,slug,meta,featured_media,full_image,full_author,full_ptymg,date,content, categories,categories_list,tags,tags_list' as const;
export const FIELDS_POST =
    'author,id,excerpt,content,title,link,slug,meta,featured_media,full_image,full_author, categories,categories_list,tags,tags_list,next,previous' as const;
export const FIELDS_RADIO =
    'id,title,link,slug,meta,featured_media,full_image,full_author,full_radio' as const;
export const FIELDS_HISTORIES =
    'id,title,link,slug,meta,featured_media,full_image,full_author' as const;
